import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  roleListApi,
  editRoleApi,
  createRoleApi,
  deleteRoleApi,
  visitorMagneticCardApi,
  visitorCardExcel,
} from "../../api/Api";
import RouteContants from "../../constants/routesContent.json";
export const SettingsRolesManagementContext = createContext({});

export const SettingsRolesManagementContextProvider = ({ children }) => {
  const [showAddRole, setShowAddRole] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [alert, setAlert] = useState(false);
  const [roleId, setRoleId] = useState(0);
  const [roleListData, setRoleListData] = useState([]);
  const [addOrEdit, setAddOrEdit] = useState("Add New Role");
  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();
  const [responseMessage, setResponseMessage] = useState("");
  const [showRoleNameRequiredError, setShowRoleNameRequiredError] =
    useState(false);
  const [noAccess, setNoAcess] = useState(false);
  const [statusCode, setStatusCode] = useState(0);
  const [cardFileDownload, setCardFileDownload] = useState();
  const [cardExcel, setCardExcel] = useState(null);
  const [fileErrorMessage, setFileErrorMessage] = useState("");
  const [cardFile, setCardFile] = useState(null);
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const navigateToRoleManagement = () => {
    navigate(RouteContants.SETTINGS_ROLE_MANAGEMENT);
  };

  const navigateToDeviceSettings = () => {
    navigate(RouteContants.SETTINGS);
  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteContants.LOGIN);
  };

  const callGetVisitorCardExcel = async () => {
    try {
      const getExcel = await visitorCardExcel();
      if (getExcel.status === 200) {
        setCardFileDownload(getExcel.data.data.filename);
      }
      console.log(getExcel);
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (
        error?.response?.data?.status === 401 ||
        error?.response?.data?.status === 400 ||
        error?.response?.data?.status === 403
      ) {
        const errorMessage = error?.response?.data?.message;
        setAlert(true);
        setResponseMessage(error?.response?.data?.message);
      } else {
        setAlert(true);
        setResponseMessage("Something went wrong");
      }
    }
  };

  const navigateToPermissions = () => {
    navigate(RouteContants.SETTINGS_PERMISSION);
  };

  const navigateToRole = (row) => {
    navigate(RouteContants.SETTINGS_ROLE, { state: row });
  };

  const goBack = () => {
    navigate(-1);
  };

  const roleListManage = async () => {
    try {
      const response = await roleListApi();
      if (response?.data?.status === 200) {
        setRoleListData(response?.data?.data?.roles);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setAlert(true);
        setResponseMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setAlert(true);

        setResponseMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setNoAcess(true);
        setResponseMessage(error?.response?.data?.message);
      } else {
        setAlert(true);
        setResponseMessage("Something went wrong");
      }
    }
  };

  const editRoleData = async () => {
    const rolenameError = roleNameValidationCheck(roleName);
    const roleData = {
      roleName: roleName,
      description: "",
    };
    if (rolenameError === false) {
      try {
        const response = await editRoleApi(roleId, roleData);
        if (response.data.status === 200) {
          setAlert(true);
          setResponseMessage(response.data.message);
        }
      } catch (error) {
        setStatusCode(error?.response?.data?.status);
        if (error?.response?.data?.status === 401) {
          setAlert(true);
          setResponseMessage(error?.response?.data?.message);
        } else if (error?.response?.data?.status === 400) {
          setAlert(true);

          setResponseMessage(error?.response?.data?.message);
        } else if (error?.response?.data?.status === 403) {
          setNoAcess(true);
          setResponseMessage(error?.response?.data?.message);
        } else {
          setAlert(true);
          setResponseMessage("Something went wrong");
        }
      }
    } else {
      setAlert(false);
    }
  };
  const roleNameValidationCheck = (roleName) => {
    if (roleName) {
      setShowRoleNameRequiredError(false);
      return false;
    } else {
      setShowRoleNameRequiredError(true);
      return true;
    }
  };
  const createRoleData = async () => {
    const rolenameError = roleNameValidationCheck(roleName);
    const roleData = {
      roleName: roleName,
      description: "",
    };
    if (rolenameError === false) {
      try {
        const response = await createRoleApi(roleData);

        if (response?.data?.status === 200) {
          setAlert(true);
          setResponseMessage(response?.data?.message);
        }
      } catch (error) {
        setStatusCode(error?.response?.data?.status);
        if (error?.response?.data?.status === 401) {
          setAlert(true);
          setResponseMessage(error?.response?.data?.message);
        } else if (error?.response?.data?.status === 400) {
          setAlert(true);

          setResponseMessage(error?.response?.data?.message);
        } else if (error?.response?.data?.status === 403) {
          setNoAcess(true);
          setResponseMessage(error?.response?.data?.message);
        } else {
          setAlert(true);
          setResponseMessage("Something went wrong");
        }
      }
    } else {
      setAlert(false);
    }
  };

  const deleteRole = async (id) => {
    try {
      const response = await deleteRoleApi(id);
      if (response.data.status === 200) {
        setAlert(true);
        setResponseMessage(response.data.message);
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 401) {
        setAlert(true);
        setResponseMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 400) {
        setAlert(true);

        setResponseMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setNoAcess(true);
        setResponseMessage(error?.response?.data?.message);
      } else {
        setAlert(true);
        setResponseMessage("Something went wrong");
      }
    }
  };

  // file upload validation
  const handleCardValidation = (value) => {
    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    if (!value) {
      setFileErrorMessage("Upload .xlsx file");
      return false;
    } else if (!allowedTypes.includes(value.type)) {
      setFileErrorMessage("Please upload .xlsx file");
      return false;
    }
    // else if (value.size > maxSizeInBytes) {
    //   setImageErrorMessage(pageContent.imageSizeValidationMessage);
    //   return false;
    // }
    else {
      setFileErrorMessage("");
      return true;
    }
  };

  const handleAlertSubmit = () => {
    setAlert(false);
  };

  const handleMagneticUpload = (event) => {
    setCardFile(event?.target?.files[0]);
    setCardExcel(event?.target?.files[0]?.name);
  };
  const editvistorData = () => {
    let formData = new FormData();
    formData.append("visitorCard", cardFile);

    return formData;
  };

  const visitorCardSubmit = async (e) => {
    e.preventDefault();
    const cardData = {
      visitorCard: cardFile,
    };
    const fileData = handleCardValidation(cardFile);
    if (fileData) {
      setSpinnerStatus(true);
      try {
        const file = await visitorMagneticCardApi(editvistorData(), cardData);
        if (file?.data?.status === 200) {
          setAlert(true);
          setSpinnerStatus(false);
          setResponseMessage(file?.data?.message);
          setCardExcel(null);
          setCardFile(null);
        }
      } catch (error) {
        setStatusCode(error?.response?.data?.status);
        if (
          error?.response?.data?.status === 401 ||
          error?.response?.data?.status === 400 ||
          error?.response?.data?.status === 403
        ) {
          const errorMessage = error?.response?.data?.message;
          setAlert(true);
          setSpinnerStatus(false);
          setResponseMessage(errorMessage);
        } else {
          setAlert(true);
          setResponseMessage("Something went wrong");
        }
      }
    }
  };

  const onRoleNameChange = (e) => {
    let value = e.target.value;
    value = value.replace(/^ |[^a-zA-Z\s]/g, "");
    setRoleName(value);
    roleNameValidationCheck(e.target.value);
  };

  useEffect(() => {
    callGetVisitorCardExcel();
  }, []);

  const providerValue = {
    navigateToDeviceSettings,
    roleName,
    navigateToPermissions,
    navigateToRole,
    setRoleId,
    goBack,
    deleteRole,
    editRoleData,
    roleListData,
    showAddRole,
    setShowAddRole,
    spinnerStatus,
    roleListManage,
    setRoleName,
    alert,
    navigateToRoleManagement,
    responseMessage,
    setAlert,
    addOrEdit,
    setAddOrEdit,
    isEdit,
    setIsEdit,
    createRoleData,
    showRoleNameRequiredError,
    setShowRoleNameRequiredError,
    noAccess,
    setNoAcess,
    logout,
    statusCode,

    handleMagneticUpload,
    setFileErrorMessage,
    fileErrorMessage,
    visitorCardSubmit,
    cardExcel,
    handleAlertSubmit,
    cardFileDownload,
    onRoleNameChange,
  };
  return (
    <SettingsRolesManagementContext.Provider value={providerValue}>
      {children}
    </SettingsRolesManagementContext.Provider>
  );
};
